module.exports = __webpack_public_path__ + "static/ansvarsrett-b37ff2c632b679d688b1fb4666bf0b04.jpg";